import React from "react";


export default function FilterBar({ children, className = "" }) {
  return (
    <div className={`filter-bar-ui ${className}`.trim()}>
      {children}
    </div>
  );
}